/* loaded by smart-asset */
export default require("./assets/pallet-damaged.i.svg")